import { Component, input, InputSignal } from '@angular/core';

import { SuccessStoriesSection } from '@core/cms/landing.cms';
import { CmsImage } from '@shared/ui/cms-image/cms-image';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/** Renders a `ComponentSectionSuccessStories`: intro content + a grid of testimonial cards. */
@Component({
    selector: 'cms-success-stories',
    imports: [CmsImage, TrustHtmlPipe],
    templateUrl: './success-stories.html',
    styleUrl: './success-stories.scss',
})
export class CmsSuccessStories {
    public readonly section: InputSignal<SuccessStoriesSection> =
        input.required<SuccessStoriesSection>();
}
